module.exports = __webpack_public_path__ + "img/content.5c0af15e.png";